import * as logger from './logger-service';
import * as localStorage from './local-storage-service';

export default {
  logger,
  localStorage,
};
